var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _c("div", { staticClass: "page-titles border-bottom" }, [
      _c("h3", [_vm._v("Transcript")]),
      _vm._v(" "),
      _vm.transcript.title
        ? _c(
            "span",
            { staticClass: "card-subtitle" },
            [
              _vm._v(
                _vm._s(_vm.transcript.title) +
                  " (" +
                  _vm._s(_vm._f("momentDateTime")(_vm.transcript.held_at)) +
                  " // "
              ),
              _vm._l(_vm.transcript.participants, function (participant) {
                return _c(
                  "span",
                  { staticClass: "pta-transcript-participant" },
                  [_vm._v(_vm._s(participant.email))]
                )
              }),
              _vm._v(")"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-info btn-sm pull-right",
          on: {
            click: function ($event) {
              return _vm.$router.push("/account/transcripts")
            },
          },
        },
        [
          _c("i", { staticClass: "fas fa-list" }),
          _vm._v(" "),
          _c("span", { staticClass: "d-none d-sm-inline" }, [
            _vm._v(_vm._s(_vm.trans("transcript.transcript_list"))),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticStyle: { width: "800px", float: "left" } }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-12 col-sm-12",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _vm._v(
                    "\n                  The investor and general partner could not be determined automatically. Please select the appropriate one in each case if present.\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 col-sm-12",
                  style: _vm.showUserSave
                    ? "margin-bottom:10px;"
                    : "margin-bottom:40px;",
                },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("General Partner"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "email",
                      "track-by": "id",
                      name: "user_id",
                      id: "user_id",
                      options: _vm.users.data,
                      placeholder: "Enter general partner name to search ...",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      showNoOptions: false,
                      "hide-selected": true,
                      placeholder: "Enter general partner name to search ...",
                      selectLabel: "choose",
                    },
                    on: {
                      input: function ($event) {
                        _vm.showUserSave = true
                      },
                      "search-change": (val) => _vm.searchUser(val),
                    },
                    model: {
                      value: _vm.user,
                      callback: function ($$v) {
                        _vm.user = $$v
                      },
                      expression: "user",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showUserSave
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 col-sm-12",
                      staticStyle: { "margin-bottom": "40px" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info",
                          attrs: { type: "button" },
                          on: { click: _vm.saveUser },
                        },
                        [_vm._v("Save")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12 col-sm-12",
                  style: _vm.showInvestorSave
                    ? "margin-bottom:10px;"
                    : "margin-bottom:40px;",
                },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Investor")]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "investor_id",
                      id: "investor_id",
                      options: _vm.investors.data,
                      placeholder: "Enter investor name to search ...",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      showNoOptions: false,
                      "hide-selected": true,
                      placeholder: "Enter investor name to search ...",
                      selectLabel: "choose",
                    },
                    on: {
                      input: function ($event) {
                        _vm.showInvestorSave = true
                      },
                      "search-change": (val) => _vm.searchInvestor(val),
                    },
                    model: {
                      value: _vm.investor,
                      callback: function ($$v) {
                        _vm.investor = $$v
                      },
                      expression: "investor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showInvestorSave
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 col-sm-12",
                      staticStyle: { "margin-bottom": "40px" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info",
                          attrs: { type: "button" },
                          on: { click: _vm.saveInvestor },
                        },
                        [_vm._v("Save")]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.investor.id
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6 col-sm-6" }, [
                    _c(
                      "h4",
                      {
                        staticClass: "card-title",
                        staticStyle: {
                          background: "#34A7C2",
                          "font-weight": "600",
                          color: "#fff",
                          padding: "10px",
                          "margin-bottom": "30px",
                        },
                      },
                      [_vm._v("Current Data")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-12" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Active"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.active,
                                      expression: "investor.active",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "esg",
                                    placeholder: _vm.trans("transcript.active"),
                                  },
                                  domProps: { value: _vm.investor.active },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "active",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("ESG Status"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.esg_status,
                                      expression: "investor.esg_status",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "esg",
                                    placeholder: _vm.trans("transcript.esg"),
                                  },
                                  domProps: { value: _vm.investor.esg_status },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "esg_status",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Open to First-Time Funds"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor.open_to_first_time_funds,
                                      expression:
                                        "investor.open_to_first_time_funds",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "fund_first_time",
                                    placeholder: _vm.trans(
                                      "transcript.fund_first_time"
                                    ),
                                  },
                                  domProps: {
                                    value:
                                      _vm.investor.open_to_first_time_funds,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "open_to_first_time_funds",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Holding Period"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.holding_period,
                                      expression: "investor.holding_period",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "holding_period",
                                    placeholder: _vm.trans(
                                      "transcript.holding_period"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.holding_period,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "holding_period",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Preferred Fund Type - Organization"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor
                                          .preferred_fund_type_organization,
                                      expression:
                                        "investor.preferred_fund_type_organization",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "preferred_fund_type_organization",
                                    placeholder: _vm.trans(
                                      "transcript.preferred_fund_type"
                                    ),
                                  },
                                  domProps: {
                                    value:
                                      _vm.investor
                                        .preferred_fund_type_organization,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "preferred_fund_type_organization",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Preferred Geography"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.preferred_geography,
                                      expression:
                                        "investor.preferred_geography",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "preferred_geography",
                                    placeholder: _vm.trans(
                                      "transcript.preferred_geography"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.preferred_geography,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "preferred_geography",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Description"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.description,
                                      expression: "investor.description",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "description",
                                    placeholder: _vm.trans(
                                      "transcript.description"
                                    ),
                                  },
                                  domProps: { value: _vm.investor.description },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "description",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Policy Description"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.policy_description,
                                      expression: "investor.policy_description",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "policy_description",
                                    placeholder: _vm.trans(
                                      "transcript.policy_description"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.policy_description,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "policy_description",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Limited Partner Type – Organization"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor
                                          .limited_partner_type_organization,
                                      expression:
                                        "investor.limited_partner_type_organization",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "partner_type",
                                    placeholder: _vm.trans(
                                      "transcript.partner_type"
                                    ),
                                  },
                                  domProps: {
                                    value:
                                      _vm.investor
                                        .limited_partner_type_organization,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "limited_partner_type_organization",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Investment Structure"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.investment_structure,
                                      expression:
                                        "investor.investment_structure",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "inv_struct",
                                    placeholder: _vm.trans(
                                      "transcript.inv_struct"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.investment_structure,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "investment_structure",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Preferred Commitment Size (USD MN)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor.preferred_commitment_size,
                                      expression:
                                        "investor.preferred_commitment_size",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "preferred_commitment_size",
                                    placeholder: _vm.trans(
                                      "transcript.preferred_commitment_size"
                                    ),
                                  },
                                  domProps: {
                                    value:
                                      _vm.investor.preferred_commitment_size,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "preferred_commitment_size",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Commitments"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.commitments,
                                      expression: "investor.commitments",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "commitments",
                                    placeholder: _vm.trans(
                                      "transcript.commitments"
                                    ),
                                  },
                                  domProps: { value: _vm.investor.commitments },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "commitments",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Commitments in RE Funds"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor.commitments_in_re_funds,
                                      expression:
                                        "investor.commitments_in_re_funds",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "commitments_re",
                                    placeholder: _vm.trans(
                                      "transcript.commitments_re"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.commitments_in_re_funds,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "commitments_in_re_funds",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Commitments in VC Funds"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor.commitments_in_vc_funds,
                                      expression:
                                        "investor.commitments_in_vc_funds",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "commitments_vc",
                                    placeholder: _vm.trans(
                                      "transcript.commitments_vc"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.commitments_in_vc_funds,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "commitments_in_vc_funds",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Commitments in Infrastructure"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor
                                          .commitments_in_infrastructure,
                                      expression:
                                        "investor.commitments_in_infrastructure",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "commitments_inv",
                                    placeholder: _vm.trans(
                                      "transcript.commitments_inv"
                                    ),
                                  },
                                  domProps: {
                                    value:
                                      _vm.investor
                                        .commitments_in_infrastructure,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "commitments_in_infrastructure",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Commitments in PE Funds"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor.commitments_in_pe_funds,
                                      expression:
                                        "investor.commitments_in_pe_funds",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "commitments_pe",
                                    placeholder: _vm.trans(
                                      "transcript.commitments_pe"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.commitments_in_pe_funds,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "commitments_in_pe_funds",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Alternative Investments (%)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor
                                          .alternative_investments_perc,
                                      expression:
                                        "investor.alternative_investments_perc",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "inv_alt",
                                    placeholder:
                                      _vm.trans("transcript.inv_alt"),
                                  },
                                  domProps: {
                                    value:
                                      _vm.investor.alternative_investments_perc,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "alternative_investments_perc",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Real Estate (%)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.real_estate_perc,
                                      expression: "investor.real_estate_perc",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "real_estate_perc",
                                    placeholder: _vm.trans(
                                      "transcript.real_estate_perc"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.real_estate_perc,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "real_estate_perc",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Private Equity (%)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.real_estate_perc,
                                      expression: "investor.real_estate_perc",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "private_equity_perc",
                                    placeholder: _vm.trans(
                                      "transcript.private_equity_perc"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.real_estate_perc,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "real_estate_perc",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Alternative Investments (USD MN)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor
                                          .alternative_investments_amn,
                                      expression:
                                        "investor.alternative_investments_amn",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "alternative_investments",
                                    placeholder: _vm.trans(
                                      "transcript.alternative_investments"
                                    ),
                                  },
                                  domProps: {
                                    value:
                                      _vm.investor.alternative_investments_amn,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "alternative_investments_amn",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Real Estate (USD MN)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.real_estate_amn,
                                      expression: "investor.real_estate_amn",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "real_estate_amount",
                                    placeholder: _vm.trans(
                                      "transcript.real_estate_amount"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.real_estate_amn,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "real_estate_amn",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Private Equity (USD MN)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.private_equity_amn,
                                      expression: "investor.private_equity_amn",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "private_equity_amount",
                                    placeholder: _vm.trans(
                                      "transcript.private_equity_amount"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.private_equity_amn,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "private_equity_amn",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Number of employees"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.number_of_employees,
                                      expression:
                                        "investor.number_of_employees",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "number_of_employees",
                                    placeholder: _vm.trans(
                                      "transcript.number_of_employees"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.number_of_employees,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "number_of_employees",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("IRR %"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.irr_perc,
                                      expression: "investor.irr_perc",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "irr",
                                    placeholder: _vm.trans("transcript.irr"),
                                  },
                                  domProps: { value: _vm.investor.irr_perc },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "irr_perc",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Equity Multiple / MOIC (x)"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.moic,
                                      expression: "investor.moic",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "moic",
                                    placeholder: _vm.trans("transcript.moic"),
                                  },
                                  domProps: { value: _vm.investor.moic },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "moic",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Fund Status"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.fund_status,
                                      expression: "investor.fund_status",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "fund_status",
                                    placeholder: _vm.trans(
                                      "transcript.fund_status"
                                    ),
                                  },
                                  domProps: { value: _vm.investor.fund_status },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "fund_status",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v(
                                    "Assets Under Management (AUM) (USD MN)"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.investor.assets_under_management,
                                      expression:
                                        "investor.assets_under_management",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "assets_amount",
                                    placeholder: _vm.trans(
                                      "transcript.assets_amount"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.assets_under_management,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "assets_under_management",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("HQ City"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.hq_city,
                                      expression: "investor.hq_city",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "hq_city",
                                    placeholder:
                                      _vm.trans("transcript.hq_city"),
                                  },
                                  domProps: { value: _vm.investor.hq_city },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "hq_city",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("HQ Country"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.hq_country,
                                      expression: "investor.hq_country",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "hq_country",
                                    placeholder: _vm.trans(
                                      "transcript.hq_country"
                                    ),
                                  },
                                  domProps: { value: _vm.investor.hq_country },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "hq_country",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "52px" },
                              },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("HQ Global Sub Region"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.investor.hq_global_sub_region,
                                      expression:
                                        "investor.hq_global_sub_region",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    readonly: true,
                                    type: "text",
                                    value: "",
                                    name: "hq_global_sub_region",
                                    placeholder: _vm.trans(
                                      "transcript.hq_global_sub_region"
                                    ),
                                  },
                                  domProps: {
                                    value: _vm.investor.hq_global_sub_region,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.investor,
                                        "hq_global_sub_region",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("HQ Global Region"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.investor.hq_global_region,
                                    expression: "investor.hq_global_region",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  readonly: true,
                                  type: "text",
                                  value: "",
                                  name: "hq_global_region",
                                  placeholder: _vm.trans(
                                    "transcript.hq_global_region"
                                  ),
                                },
                                domProps: {
                                  value: _vm.investor.hq_global_region,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.investor,
                                      "hq_global_region",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 col-sm-6" }, [
                    _c(
                      "h4",
                      {
                        staticClass: "card-title",
                        staticStyle: {
                          background: "#0FB5AA",
                          "font-weight": "600",
                          color: "#fff",
                          padding: "10px",
                          "margin-bottom": "30px",
                        },
                      },
                      [_vm._v("New Data")]
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.submit.apply(null, arguments)
                          },
                          keydown: function ($event) {
                            return _vm.investorForm.errors.clear(
                              $event.target.name
                            )
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Active"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.transcriptForm.active,
                                            expression: "transcriptForm.active",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { name: "active" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.transcriptForm,
                                              "active",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("Not specified"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Yes" } },
                                          [_vm._v("Yes")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "No" } },
                                          [_vm._v("No")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.active_action,
                                                expression: "active_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c31",
                                              name: "c31",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.active_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "active"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.active_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c31" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.active_action,
                                                expression: "active_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c32",
                                              name: "c32",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.active_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "active"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.active_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c32" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "active",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("ESG Status"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.transcriptForm.esg,
                                            expression: "transcriptForm.esg",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { name: "active" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.transcriptForm,
                                              "esg",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("Not specified"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Yes" } },
                                          [_vm._v("Yes")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "No" } },
                                          [_vm._v("No")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Considering" } },
                                          [_vm._v("Considering")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Pending" } },
                                          [_vm._v("Pending")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.esg_status_action,
                                                expression: "esg_status_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c1",
                                              name: "c1",
                                              value: "1",
                                              checked: "checked",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.esg_status_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite("esg")
                                              },
                                              change: function ($event) {
                                                _vm.esg_status_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c1" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.esg_status_action,
                                                expression: "esg_status_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c2",
                                              name: "c2",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.esg_status_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite("esg")
                                              },
                                              change: function ($event) {
                                                _vm.esg_status_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c2" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "esg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Open to First-Time Funds"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.transcriptForm.ftf,
                                            expression: "transcriptForm.ftf",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { name: "active" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.transcriptForm,
                                              "ftf",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("Not specified"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Yes" } },
                                          [_vm._v("Yes")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "No" } },
                                          [_vm._v("No")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Spin-Offs" } },
                                          [_vm._v("Spin-Offs")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Considering" } },
                                          [_vm._v("Considering")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.open_to_first_time_funds_action,
                                                expression:
                                                  "open_to_first_time_funds_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c13",
                                              name: "c13",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.open_to_first_time_funds_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite("ftf")
                                              },
                                              change: function ($event) {
                                                _vm.open_to_first_time_funds_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c13" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.open_to_first_time_funds_action,
                                                expression:
                                                  "open_to_first_time_funds_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c14",
                                              name: "c14",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.open_to_first_time_funds_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite("ftf")
                                              },
                                              change: function ($event) {
                                                _vm.open_to_first_time_funds_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c14" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "fund_first_time",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Holding Period"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.period,
                                          expression: "transcriptForm.period",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "holding_period",
                                        placeholder: _vm.trans(
                                          "transcript.holding_period"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.period,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "period",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.holding_period_action,
                                                expression:
                                                  "holding_period_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c3",
                                              name: "c3",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.holding_period_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "period"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.holding_period_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c3" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.holding_period_action,
                                                expression:
                                                  "holding_period_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c4",
                                              name: "c4",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.holding_period_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "period"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.holding_period_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c4" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "holding_period",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v(
                                        "Preferred Fund Type - Organization"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.fundtype,
                                          expression: "transcriptForm.fundtype",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "preferred_fund_type",
                                        placeholder: _vm.trans(
                                          "transcript.preferred_fund_type"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.fundtype,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "fundtype",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_fund_type_action,
                                                expression:
                                                  "preferred_fund_type_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c7",
                                              name: "c7",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_fund_type_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "fundtype"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.preferred_fund_type_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c7" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_fund_type_action,
                                                expression:
                                                  "preferred_fund_type_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c8",
                                              name: "c8",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_fund_type_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "fundtype"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.preferred_fund_type_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c8" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_fund_type_action,
                                                expression:
                                                  "preferred_fund_type_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c9",
                                              name: "c9",
                                              value: "3",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_fund_type_action,
                                                "3"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.preferred_fund_type_action =
                                                  "3"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c9" } },
                                            [_vm._v("Add")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "preferred_fund_type",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Preferred Geography"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.geography,
                                          expression:
                                            "transcriptForm.geography",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "preferred_geography",
                                        placeholder: _vm.trans(
                                          "transcript.preferred_geography"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.geography,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "geography",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_geography_action,
                                                expression:
                                                  "preferred_geography_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c10",
                                              name: "c10",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_geography_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "geography"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.preferred_geography_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c10" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_geography_action,
                                                expression:
                                                  "preferred_geography_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c11",
                                              name: "c11",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_geography_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "geography"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.preferred_geography_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c11" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_geography_action,
                                                expression:
                                                  "preferred_geography_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c12",
                                              name: "c12",
                                              value: "3",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_geography_action,
                                                "3"
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.preferred_geography_action =
                                                  "3"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c12" } },
                                            [_vm._v("Add")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "preferred_geography",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Description"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.description,
                                          expression:
                                            "transcriptForm.description",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "description",
                                        placeholder: _vm.trans(
                                          "transcript.description"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.description,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "description",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.description_action,
                                                expression:
                                                  "description_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c51",
                                              name: "c51",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.description_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "description"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.description_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c51" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.description_action,
                                                expression:
                                                  "description_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c52",
                                              name: "c52",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.description_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "description"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.description_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c52" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Policy Description"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.policy,
                                          expression: "transcriptForm.policy",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "policy_description",
                                        placeholder: _vm.trans(
                                          "transcript.policy_description"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.policy,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "policy",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.policy_description_action,
                                                expression:
                                                  "policy_description_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c53",
                                              name: "c53",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.policy_description_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "policy"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.policy_description_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c53" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.policy_description_action,
                                                expression:
                                                  "policy_description_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c54",
                                              name: "c54",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.policy_description_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "policy"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.policy_description_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c54" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v(
                                        "Limited Partner Type – Organization"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.transcriptForm.partner_type,
                                            expression:
                                              "transcriptForm.partner_type",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { name: "active" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.transcriptForm,
                                              "partner_type",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("Not specified"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Corporate Pension",
                                            },
                                          },
                                          [_vm._v("Corporate Pension")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Public Pension Fund",
                                            },
                                          },
                                          [_vm._v("Public Pension Fund")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Union Pension Fund",
                                            },
                                          },
                                          [_vm._v("Union Pension Fund")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Family Office (Single)",
                                            },
                                          },
                                          [_vm._v("Family Office (Single)")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Family Office (Multi)",
                                            },
                                          },
                                          [_vm._v("Family Office (Multi)")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Direct Investment",
                                            },
                                          },
                                          [_vm._v("Direct Investment")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Fund of Funds" } },
                                          [_vm._v("Fund of Funds")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Insurance Company",
                                            },
                                          },
                                          [_vm._v("Insurance Company")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Mutual Fund Company",
                                            },
                                          },
                                          [_vm._v("Mutual Fund Company")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Private Investment Fund",
                                            },
                                          },
                                          [_vm._v("Private Investment Fund")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value:
                                                "Real Estate Investment Company",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Real Estate Investment Company"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Secondary LP" } },
                                          [_vm._v("Secondary LP")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value:
                                                "Economic Development Agency",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "Economic Development Agency"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Endowment" } },
                                          [_vm._v("Endowment")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value:
                                                "University (Non-Endowment)",
                                            },
                                          },
                                          [_vm._v("University (Non-Endowment)")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Foundation" } },
                                          [_vm._v("Foundation")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Government Agency",
                                            },
                                          },
                                          [_vm._v("Government Agency")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Sovereign Wealth Fund",
                                            },
                                          },
                                          [_vm._v("Sovereign Wealth Fund")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Discretionary Advisor",
                                            },
                                          },
                                          [_vm._v("Discretionary Advisor")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Investment Advisor",
                                            },
                                          },
                                          [_vm._v("Investment Advisor")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Money Management Firm",
                                            },
                                          },
                                          [_vm._v("Money Management Firm")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Wealth Management Firm",
                                            },
                                          },
                                          [_vm._v("Wealth Management Firm")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Banking Institution",
                                            },
                                          },
                                          [_vm._v("Banking Institution")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Corporation" } },
                                          [_vm._v("Corporation")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "High-net-worth Investor",
                                            },
                                          },
                                          [_vm._v("High-net-worth Investor")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Other Limited Partner",
                                            },
                                          },
                                          [_vm._v("Other Limited Partner")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "Institutional Investor",
                                            },
                                          },
                                          [_vm._v("Institutional Investor")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.partner_type_action,
                                                expression:
                                                  "partner_type_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c55",
                                              name: "c55",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.partner_type_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "partner_type"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.partner_type_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c55" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.partner_type_action,
                                                expression:
                                                  "partner_type_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c56",
                                              name: "c56",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.partner_type_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "partner_type"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.partner_type_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c56" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Investment Structure"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.transcriptForm.inv_struct,
                                            expression:
                                              "transcriptForm.inv_struct",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { name: "active" },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              _vm.transcriptForm,
                                              "inv_struct",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("Not specified"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Direct deal" } },
                                          [_vm._v("Direct Deal Investment ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: { value: "Fund investment" },
                                          },
                                          [_vm._v("Fund Investment ")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.inv_struct_action,
                                                expression: "inv_struct_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c57",
                                              name: "c57",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.inv_struct_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "inv_struct"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.inv_struct_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c57" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.inv_struct_action,
                                                expression: "inv_struct_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c58",
                                              name: "c58",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.inv_struct_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "inv_struct"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.inv_struct_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c58" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Preferred Commitment Size"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm
                                              .preferred_commitment_size,
                                          expression:
                                            "transcriptForm.preferred_commitment_size",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "preferred_commitment_size",
                                        placeholder: _vm.trans(
                                          "transcript.preferred_commitment_size"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm
                                            .preferred_commitment_size,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "preferred_commitment_size",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_commitment_size_action,
                                                expression:
                                                  "preferred_commitment_size_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c59",
                                              name: "c59",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_commitment_size_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "preferred_commitment_size"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.preferred_commitment_size_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c59" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preferred_commitment_size_action,
                                                expression:
                                                  "preferred_commitment_size_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c60",
                                              name: "c60",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preferred_commitment_size_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "preferred_commitment_size"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.preferred_commitment_size_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c60" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Commitments"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.commitments,
                                          expression:
                                            "transcriptForm.commitments",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "commitments",
                                        placeholder: _vm.trans(
                                          "transcript.commitments"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.commitments,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "commitments",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.commitments_action,
                                                expression:
                                                  "commitments_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c61",
                                              name: "c61",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "commitments"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c61" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.commitments_action,
                                                expression:
                                                  "commitments_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c62",
                                              name: "c62",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "commitments"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c62" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Commitments in RE Funds"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm.commitments_re,
                                          expression:
                                            "transcriptForm.commitments_re",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "commitments_re",
                                        placeholder: _vm.trans(
                                          "transcript.commitments_re"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm.commitments_re,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "commitments_re",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_re_action,
                                                expression:
                                                  "commitments_re_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c63",
                                              name: "c63",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_re_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "commitments_re"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_re_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c63" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_re_action,
                                                expression:
                                                  "commitments_re_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c64",
                                              name: "c64",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_re_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "commitments_re"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_re_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c64" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Commitments in VC Funds"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm.commitments_vc,
                                          expression:
                                            "transcriptForm.commitments_vc",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "commitments_vc",
                                        placeholder: _vm.trans(
                                          "transcript.commitments_vc"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm.commitments_vc,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "commitments_vc",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_vc_action,
                                                expression:
                                                  "commitments_vc_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c65",
                                              name: "c65",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_vc_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "commitments_vc"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_vc_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c65" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_vc_action,
                                                expression:
                                                  "commitments_vc_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c66",
                                              name: "c66",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_vc_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "commitments_vc"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_vc_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c66" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Commitments in Infrastructure"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm.commitments_inv,
                                          expression:
                                            "transcriptForm.commitments_inv",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "commitments_inv",
                                        placeholder: _vm.trans(
                                          "transcript.commitments_inv"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm.commitments_inv,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "commitments_inv",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_inv_action,
                                                expression:
                                                  "commitments_inv_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c67",
                                              name: "c67",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_inv_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "commitments_inv"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_inv_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c67" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_inv_action,
                                                expression:
                                                  "commitments_inv_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c68",
                                              name: "c68",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_inv_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "commitments_inv"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_inv_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c68" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Commitments in PE Funds"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm.commitments_pe,
                                          expression:
                                            "transcriptForm.commitments_pe",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "commitments_pe",
                                        placeholder: _vm.trans(
                                          "transcript.commitments_pe"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm.commitments_pe,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "commitments_pe",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_pe_action,
                                                expression:
                                                  "commitments_pe_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c69",
                                              name: "c69",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_pe_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "commitments_pe"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_pe_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c69" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.commitments_pe_action,
                                                expression:
                                                  "commitments_pe_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c70",
                                              name: "c70",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.commitments_pe_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "commitments_pe"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.commitments_pe_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c70" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Alternative Investments (%)"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.inv_alt,
                                          expression: "transcriptForm.inv_alt",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "inv_alt",
                                        placeholder:
                                          _vm.trans("transcript.inv_alt"),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.inv_alt,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "inv_alt",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.inv_alt_action,
                                                expression: "inv_alt_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c71",
                                              name: "c71",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.inv_alt_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "inv_alt"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.inv_alt_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c71" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.inv_alt_action,
                                                expression: "inv_alt_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c72",
                                              name: "c72",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.inv_alt_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "inv_alt"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.inv_alt_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c72" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Real Estate (%)"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm.real_estate_perc,
                                          expression:
                                            "transcriptForm.real_estate_perc",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "real_estate_perc",
                                        placeholder: _vm.trans(
                                          "transcript.real_estate_perc"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm.real_estate_perc,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "real_estate_perc",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.real_estate_perc_action,
                                                expression:
                                                  "real_estate_perc_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c73",
                                              name: "c73",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.real_estate_perc_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "real_estate_perc"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.real_estate_perc_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c73" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.real_estate_perc_action,
                                                expression:
                                                  "real_estate_perc_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c74",
                                              name: "c74",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.real_estate_perc_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "real_estate_perc"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.real_estate_perc_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c74" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Private Equity (%)"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm
                                              .private_equity_perc,
                                          expression:
                                            "transcriptForm.private_equity_perc",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "private_equity_perc",
                                        placeholder: _vm.trans(
                                          "transcript.private_equity_perc"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm
                                            .private_equity_perc,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "private_equity_perc",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.private_equity_perc_action,
                                                expression:
                                                  "private_equity_perc_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c75",
                                              name: "c75",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.private_equity_perc_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "private_equity_perc"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.private_equity_perc_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c75" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.private_equity_perc_action,
                                                expression:
                                                  "private_equity_perc_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c76",
                                              name: "c76",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.private_equity_perc_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "private_equity_perc"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.private_equity_perc_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c76" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v(
                                        "Alternative Investments (USD MN)"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm
                                              .alternative_investments,
                                          expression:
                                            "transcriptForm.alternative_investments",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "alternative_investments",
                                        placeholder: _vm.trans(
                                          "transcript.alternative_investments"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm
                                            .alternative_investments,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "alternative_investments",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.alternative_investments_action,
                                                expression:
                                                  "alternative_investments_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c77",
                                              name: "c77",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.alternative_investments_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "alternative_investments"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.alternative_investments_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c77" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.alternative_investments_action,
                                                expression:
                                                  "alternative_investments_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c78",
                                              name: "c78",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.alternative_investments_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "alternative_investments"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.alternative_investments_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c78" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Real Estate (USD MN)"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm
                                              .real_estate_amount,
                                          expression:
                                            "transcriptForm.real_estate_amount",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "real_estate_amount",
                                        placeholder: _vm.trans(
                                          "transcript.real_estate_amount"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm.real_estate_amount,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "real_estate_amount",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.real_estate_amount_action,
                                                expression:
                                                  "real_estate_amount_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c79",
                                              name: "c79",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.real_estate_amount_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "real_estate_amount"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.real_estate_amount_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c79" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.real_estate_amount_action,
                                                expression:
                                                  "real_estate_amount_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c80",
                                              name: "c80",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.real_estate_amount_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "real_estate_amount"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.real_estate_amount_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c80" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Private Equity (USD MN)"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm
                                              .private_equity_amount,
                                          expression:
                                            "transcriptForm.private_equity_amount",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "private_equity_amount",
                                        placeholder: _vm.trans(
                                          "transcript.private_equity_amount"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm
                                            .private_equity_amount,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "private_equity_amount",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.private_equity_amount_action,
                                                expression:
                                                  "private_equity_amount_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c81",
                                              name: "c81",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.private_equity_amount_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "private_equity_amount"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.private_equity_amount_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c81" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.private_equity_amount_action,
                                                expression:
                                                  "private_equity_amount_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c82",
                                              name: "c82",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.private_equity_amount_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "private_equity_amount"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.private_equity_amount_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c82" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Number of employees"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm
                                              .number_of_employees,
                                          expression:
                                            "transcriptForm.number_of_employees",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "number_of_employees",
                                        placeholder: _vm.trans(
                                          "transcript.number_of_employees"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm
                                            .number_of_employees,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "number_of_employees",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.number_of_employees_action,
                                                expression:
                                                  "number_of_employees_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c83",
                                              name: "c83",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.number_of_employees_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "number_of_employees"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.number_of_employees_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c83" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.number_of_employees_action,
                                                expression:
                                                  "number_of_employees_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c84",
                                              name: "c84",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.number_of_employees_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "number_of_employees"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.number_of_employees_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c84" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("IRR %"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.irr,
                                          expression: "transcriptForm.irr",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "irr",
                                        placeholder:
                                          _vm.trans("transcript.irr"),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.irr,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "irr",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.irr_action,
                                                expression: "irr_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c85",
                                              name: "c85",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.irr_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite("irr")
                                              },
                                              change: function ($event) {
                                                _vm.irr_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c85" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.irr_action,
                                                expression: "irr_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c86",
                                              name: "c86",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.irr_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite("irr")
                                              },
                                              change: function ($event) {
                                                _vm.irr_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c86" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Equity Multiple / MOIC (x)"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.moic,
                                          expression: "transcriptForm.moic",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "moic",
                                        placeholder:
                                          _vm.trans("transcript.moic"),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.moic,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "moic",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.moic_action,
                                                expression: "moic_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c87",
                                              name: "c87",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.moic_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "moic"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.moic_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c87" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.moic_action,
                                                expression: "moic_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c88",
                                              name: "c88",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.moic_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite("moic")
                                              },
                                              change: function ($event) {
                                                _vm.moic_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c88" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Fund Status"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.fund_status,
                                          expression:
                                            "transcriptForm.fund_status",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "fund_status",
                                        placeholder: _vm.trans(
                                          "transcript.fund_status"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.fund_status,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "fund_status",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.fund_status_action,
                                                expression:
                                                  "fund_status_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c89",
                                              name: "c89",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.fund_status_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "fund_status"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.fund_status_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c89" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.fund_status_action,
                                                expression:
                                                  "fund_status_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c90",
                                              name: "c90",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.fund_status_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "fund_status"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.fund_status_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c90" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v(
                                        "Assets Under Management (AUM) (USD MN)"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm.assets_amount,
                                          expression:
                                            "transcriptForm.assets_amount",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "assets_amount",
                                        placeholder: _vm.trans(
                                          "transcript.assets_amount"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.assets_amount,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "assets_amount",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.assets_amount_action,
                                                expression:
                                                  "assets_amount_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c91",
                                              name: "c91",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.assets_amount_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "assets_amount"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.assets_amount_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c91" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.assets_amount_action,
                                                expression:
                                                  "assets_amount_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c92",
                                              name: "c92",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.assets_amount_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "assets_amount"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.assets_amount_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c92" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("HQ City"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.hqcity,
                                          expression: "transcriptForm.hqcity",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "hq_city",
                                        placeholder:
                                          _vm.trans("transcript.hq_city"),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.hqcity,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "hqcity",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.hq_city_action,
                                                expression: "hq_city_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c93",
                                              name: "c93",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_city_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "hqcity"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_city_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c93" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.hq_city_action,
                                                expression: "hq_city_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c94",
                                              name: "c94",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_city_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "hqcity"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_city_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c94" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("HQ Country"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.hqcountry,
                                          expression:
                                            "transcriptForm.hqcountry",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "hq_country",
                                        placeholder: _vm.trans(
                                          "transcript.hq_country"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.hqcountry,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "hqcountry",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.hq_country_action,
                                                expression: "hq_country_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c95",
                                              name: "c95",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_country_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "hqcountry"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_country_action = "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c95" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.hq_country_action,
                                                expression: "hq_country_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c96",
                                              name: "c96",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_country_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "hqcountry"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_country_action = "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c96" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("HQ Global Sub Region"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.transcriptForm
                                              .hq_global_sub_region,
                                          expression:
                                            "transcriptForm.hq_global_sub_region",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "hq_global_sub_region",
                                        placeholder: _vm.trans(
                                          "transcript.hq_global_sub_region"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.transcriptForm
                                            .hq_global_sub_region,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "hq_global_sub_region",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.hq_global_sub_region_action,
                                                expression:
                                                  "hq_global_sub_region_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c97",
                                              name: "c97",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_global_sub_region_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "hq_global_sub_region"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_global_sub_region_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c97" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.hq_global_sub_region_action,
                                                expression:
                                                  "hq_global_sub_region_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c98",
                                              name: "c98",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_global_sub_region_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "hq_global_sub_region"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_global_sub_region_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c98" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-sm-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("HQ Global Region"),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.transcriptForm.hqcontinent,
                                          expression:
                                            "transcriptForm.hqcontinent",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        value: "",
                                        name: "hq_global_region",
                                        placeholder: _vm.trans(
                                          "transcript.hq_global_region"
                                        ),
                                      },
                                      domProps: {
                                        value: _vm.transcriptForm.hqcontinent,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.transcriptForm,
                                            "hqcontinent",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "pta-transcript-actions" },
                                      [
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.hq_global_region_action,
                                                expression:
                                                  "hq_global_region_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c99",
                                              name: "c99",
                                              value: "1",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_global_region_action,
                                                "1"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.unsetOverwrite(
                                                  "hqcontinent"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_global_region_action =
                                                  "1"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c99" } },
                                            [_vm._v("Ignore")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.hq_global_region_action,
                                                expression:
                                                  "hq_global_region_action",
                                              },
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "c100",
                                              name: "c100",
                                              value: "2",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.hq_global_region_action,
                                                "2"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setOverwrite(
                                                  "hqcontinent"
                                                )
                                              },
                                              change: function ($event) {
                                                _vm.hq_global_region_action =
                                                  "2"
                                              },
                                            },
                                          }),
                                          _c(
                                            "label",
                                            { attrs: { for: "c100" } },
                                            [_vm._v("Overwrite")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("show-error", {
                                      attrs: {
                                        "form-name": _vm.transcriptForm,
                                        "prop-name": "ticket_size",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info pull-right",
                            attrs: { disabled: _vm.takeover, type: "button" },
                          },
                          [_vm._v("Take over data")]
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                float: "left",
                width: "calc(100% - 800px)",
                "padding-left": "80px",
              },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-sm-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("h4", { staticClass: "card-title" }, [
                      _vm._v("Summary"),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-12 col-sm-12",
                      staticStyle: {
                        "font-size": "14px",
                        "margin-bottom": "40px",
                        border: "1px solid #AEAEAE",
                        "border-radius": "10px",
                        padding: "20px",
                        background: "#fff",
                      },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.transcript.summary
                            ? _vm.transcript.summary
                                .toString()
                                .replace(/(?:\r\n|\r|\n)/g, "<br>")
                            : ""
                        ),
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("h4", { staticClass: "card-title" }, [_vm._v("Topics")]),
                _vm._v(" "),
                _vm.transcript.topics && _vm.transcript.topics.length
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12 col-sm-12",
                        staticStyle: {
                          "font-size": "14px",
                          "margin-bottom": "10px",
                          border: "1px solid #AEAEAE",
                          "border-radius": "10px",
                          padding: "20px",
                          background: "#fff",
                        },
                      },
                      _vm._l(_vm.transcript.topics, function (topic) {
                        return _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 col-sm-12" }, [
                            _c("h5", [_vm._v(_vm._s(topic.title))]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(topic.summary))]),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _c("div", { staticClass: "col-12 col-sm-12" }, [_vm._m(0)]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "h4",
                  {
                    staticClass: "card-title",
                    staticStyle: { "padding-top": "20px" },
                  },
                  [_vm._v("Content")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-sm-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 col-sm-12",
                        staticStyle: {
                          "font-size": "14px",
                          "margin-bottom": "10px",
                          border: "1px solid #AEAEAE",
                          "border-radius": "10px",
                          padding: "20px",
                          background: "#fff",
                        },
                      },
                      [
                        _c("div", {
                          staticStyle: {
                            height: "600px",
                            "overflow-y": "auto",
                            "padding-right": "20px",
                          },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.transcript.content
                                ? _vm.transcript.content
                                    .toString()
                                    .replace(/(?:\r\n|\r|\n)/g, "<br>")
                                : ""
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { clear: "both" } }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass: "col-12 col-sm-12",
          staticStyle: { "font-size": "14px", "margin-bottom": "10px" },
        },
        [_vm._v("-")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }